export const HEADERS = [
	'No.',
	'Resign at',
	'Resign by',
	'Resign reason',
	'Customer name',
	'Customer email',
];
